import React, { useState, useEffect } from "react";
import CONSTANTS from "../../../constants";
import Button from "../../Forms/Button";
import InputOutlined from "../../Forms/InputOutlined";
import Radio from "../../Forms/Radio";
import "./MatriculeTabFlex.scss";
import {
  setVeiculeInfos,
  CurrentStepSetAction,
  setVeiculeKilo,
  setFilterDealersBy,
} from "./../../../actions/action";
import { connect } from "react-redux";
import fetchApiData from "../../apiHandlers/fetchApiData";
import { pushEventToGTM } from "../../../helpers/trackerManager";
import PopUp from "../../popup/popup";

const mapStateToProps = (state) => state;
const mapDispatchToProps = {
  setVeiculeInfos,
  setVeiculeKilo,
  CurrentStepSetAction,
  setFilterDealersBy,
};

const MatriculeTabFlex = (props) => {
  const [showPopup, setShowPopup] = useState(false);
  const [showFiltersPopup, setShowFiltersPopup] = useState(false);
  const [step1Loading, setStep1Loading] = useState(false);
  const [step1ButtonDisabled, setStep1ButtonDisabled] = useState(true);
  const [step2ButtonDisabled, setStep2ButtonDisabled] = useState(
    !Object.values(props.store.kilo).length
  );
  const [immaInput, setImmaInput] = useState("");
  const [matriculeCodeError, setMatriculeCodeError] = useState(false);
  const [KilometrageError, setKilometrageError] = useState(false);
  const [kilometrage, setKilometrage] = useState(
    props.store.kilo.kilometrage || ""
  );
  const [contratSerivce, setContratSerivce] = useState(
    !!(
      Object.values(props.store.kilo).length > 0 &&
      props.store.kilo.contratService
    )
  );
  const [isVehiclePC, setIsVehiclePC] = useState(
    props.store.car.PC === undefined ? false : props.store.car.PC
  );
  const [isVehicleLCV, setIsVehicleLCV] = useState(
    props.store.car.LCV === undefined ? false : props.store.car.LCV
  );

  const isRecallCampagneActivate = !!Number(
    window.siteConfig.ActivateRecallCampaign
  );

  let isfiltersPopinOpen = undefined;
  let isRecallCompagnePopinOpen = undefined;

  useEffect(() => {
    setImmaInput(props.prevData.immaInput);
    setStep1ButtonDisabled(
      !(props.prevData.immaInput && props.prevData.immaInput.length > 2)
    );
  }, [setImmaInput, setStep1ButtonDisabled, props]);

  const checkMatriculCode = () => {
    const CarDetails = new fetchApiData();
    setStep1Loading(true);

    CarDetails.getImmatr(immaInput.toUpperCase())
      .then((data) => {
        switch (data.d.ErrorCode) {
          case 0:
            if (
              props.store.listPremiumServices.some(
                (item) =>
                  (item.codeIntern === "PC" || item.codeIntern === "LCV") &&
                  item.displayDL
              )
            ) {
              if (
                !(
                  data.d.VehicleInfo.LCV === props.store.dealer.LCV ||
                  data.d.VehicleInfo.PC === props.store.dealer.PC
                )
              ) {
                setShowFiltersPopup(true);
                isfiltersPopinOpen = true;
                document.body.classList.add("no-scroll");
              }
            }

            isRecallCampagneActivate &&
              checkCampagneRappel(data.d.VehicleInfo.SerialNumber);

            props.setVeiculeInfos(data.d.VehicleInfo);
            setStep1Loading(false);
            props.updateServicesAfterDataChanged();
            !isRecallCampagneActivate &&
              !isfiltersPopinOpen &&
              props.CurrentStepSetAction(4);
            pushEventToGTM({
              pageName: "car-details",
              eventAction: "Redirection::Internal::Next_step",
              eventLabel: "registration_plate",
            });

            break;
          default:
            setMatriculeCodeError(
              data.d.ErrorMessage == 1
                ? CONSTANTS.LABELS.vehicule_plate_step1_error_incorrect
                : CONSTANTS.LABELS.vehicule_plate_step1_error_unknown
            );
            setStep1Loading(false);
            break;
        }
      })
      .catch((error) => {
        console.log("fait: ", error);
        setStep1Loading(false);
      });
    props.setVeiculeKilo({
      contratService: contratSerivce,
      kilometrage: kilometrage,
      carStep: "1",
    });
  };

  const checkCampagneRappel = (serialNumber) => {
    const cpRappelData = new fetchApiData();
    cpRappelData
      .getCompagneRappelEligibility(serialNumber)
      .then((data) => {
        if (data.d.Eligible) {
          setShowPopup(true);
          document.body.classList.add("no-scroll");
          isRecallCompagnePopinOpen = true;
        }
        !isRecallCompagnePopinOpen &&
          !isfiltersPopinOpen &&
          props.CurrentStepSetAction(4);
      })
      .catch((error) => {
        console.log("fait: ", error);
      });
  };

  const continueToNextStep = (popinName) => {
    if (popinName === "recallCompaingPopin") {
      setShowPopup(false);
      document.body.classList.remove("no-scroll");
      isRecallCompagnePopinOpen = false;
    }
    if (popinName === "filterPopin") {
      setShowFiltersPopup(false);
      document.body.classList.remove("no-scroll");
      isfiltersPopinOpen = false;
    }
    if (!isRecallCompagnePopinOpen && isfiltersPopinOpen)
      props.CurrentStepSetAction(4);
  };

  const goToDealersLocator = () => {
    props.store.listPremiumServices.forEach((item) => {
      if (item.codeIntern === "LCV" && isVehicleLCV) {
        if (props.store.filterDealersBy.indexOf(item.idServicePremium) === -1) {
          props.setFilterDealersBy([
            ...props.store.filterDealersBy,
            item.idServicePremium,
          ]);
        }
      }
      if (item.codeIntern === "PC" && isVehiclePC) {
        if (props.store.filterDealersBy.indexOf(item.idServicePremium) === -1) {
          props.setFilterDealersBy([
            ...props.store.filterDealersBy,
            item.idServicePremium,
          ]);
        }
      }
    });
    props.CurrentStepSetAction(1);
  };

  useEffect(() => {
    console.log("radio value : ", contratSerivce);
  }, [contratSerivce]);

  const popInFilterContent = (
    <div className="warning-filters">
      <p className="warning-main">
        {CONSTANTS.LABELS.vehicule_filter_alert_main}
      </p>
      <div className="warning-list">
        <p className="warning-second">
          {CONSTANTS.LABELS.vehicule_filter_alert_second}
        </p>
        <li className="warning-item">
          <i className="mark-icons cross-icon" />
          <span className="warning-label">
            {CONSTANTS.LABELS.vehicule_filter_alert_warranty}{" "}
          </span>{" "}
        </li>
        <li className="warning-item">
          <i className="mark-icons cross-icon" />
          <span className="warning-label">
            {CONSTANTS.LABELS.vehicule_filter_alert_maintenance}
          </span>
        </li>
        <li className="warning-item">
          <i className="mark-icons cross-icon" />
          <span className="warning-label">
            {CONSTANTS.LABELS.vehicule_filter_alert_recall_campain}
          </span>
        </li>
        <li className="warning-item">
          <i className="mark-icons cross-icon" />
          <span className="warning-label">
            {CONSTANTS.LABELS.vehicule_filter_alert_package}
          </span>
        </li>
      </div>
    </div>
  );

  return (
    <div className="flexContainer">
      <p
        tabIndex="0"
        className="sectionIntro"
        dangerouslySetInnerHTML={{ __html: CONSTANTS.LABELS.vehicule_label1 }}
      ></p>

      <div className="subContainer">
        <InputOutlined
          title={CONSTANTS.LABELS.vehicule_plate_step1_licenseplate}
          placeholder={CONSTANTS.LABELS.vehicule_plate_step1_example}
          ariaLabel={CONSTANTS.LABELS.vehicule_plate_step1_licenseplate}
          isInvalid={matriculeCodeError}
          value={immaInput}
          onChange={(e) => {
            setImmaInput(e.target.value);
            props.dataFromChild({
              immaInput: e.target.value,
            });
            e.target.value.trim().length
              ? setStep1ButtonDisabled(false)
              : setStep1ButtonDisabled(true);
          }}
        />
      </div>

      <div className="subContainer">
        <InputOutlined
          title={CONSTANTS.LABELS.vehicule_step2_km1}
          name="distance"
          type="tel"
          ariaLabel={CONSTANTS.LABELS.vehicule_step2_km1}
          selected={kilometrage}
          isInvalid={KilometrageError}
          onChange={(e) => {
            setKilometrage(e.target.value);

            if (
              e.target.value.trim().length &&
              (Number(e.target.value) > 999999 ||
                e.target.value.trim().length > 6)
            ) {
              setStep2ButtonDisabled(true);
              setKilometrageError(
                CONSTANTS.LABELS.vehicule_step2_error_limitednumbers
              );
            } else if (
              e.target.value.trim().length &&
              !/^[0-9]*$/.test(e.target.value)
            ) {
              setStep2ButtonDisabled(true);
              setKilometrageError(
                CONSTANTS.LABELS.vehicule_step2_error_numbersonly
              );
            } else if (
              e.target.value.trim().length &&
              Number(e.target.value) === 0
            ) {
              setStep2ButtonDisabled(true);
              setKilometrageError(CONSTANTS.LABELS.vehicule_step2_error_zero);
            } else {
              setStep2ButtonDisabled(false);
              setKilometrageError(false);
            }
          }}
        />
      </div>

      <div className="radioContainer">
        <span tabIndex="0" className="styleLabel">
          {CONSTANTS.LABELS.vehicule_step2_warranty}
        </span>

        <div className="radioSubContainer">
          <Radio
            name="servieContract"
            id="servieContract-0"
            label={CONSTANTS.LABELS.vehicule_step2_warranty_yes}
            customClassName="marginButton"
            isChecked={!!contratSerivce}
            onChange={(e) => {
              setContratSerivce(true);
            }}
          />
          <Radio
            name="servieContract"
            id="servieContract-1"
            label={CONSTANTS.LABELS.vehicule_step2_warranty_no}
            isChecked={!contratSerivce}
            onChange={(e) => {
              setContratSerivce(false);
            }}
          />
        </div>
      </div>

      <div className="notInPopup">
        <Button
          onClick={checkMatriculCode}
          Disabled={
            step1ButtonDisabled || step2ButtonDisabled || kilometrage.length < 1
          }
        >
          {CONSTANTS.LABELS.common_v2_nextstep}
        </Button>
      </div>

      {showPopup && (
        <PopUp
          title={CONSTANTS.LABELS.vehicule_step2recalleligibility}
          content={CONSTANTS.LABELS.vehicule_step2recalleligibilitycontent}
          primaryButtonLabel={
            CONSTANTS.LABELS.vehicule_step2recalleligibilityagreement
          }
          handlePrimaryButton={() => {
            continueToNextStep("recallCompaingPopin");
          }}
        />
      )}

      {// filter LCV/PC incompatibility between vehicle and dealer
      showFiltersPopup && (
        <PopUp
          title={CONSTANTS.LABELS.vehicule_filter_alert_title}
          content={popInFilterContent}
          primaryButtonLabel={CONSTANTS.LABELS.vehicule_filter_other_dealer}
          secondaryButtonLabel={CONSTANTS.LABELS.vehicule_filter_ignore}
          handlePrimaryButton={() => goToDealersLocator()}
          handleSecondaryButton={() => {
            continueToNextStep("filterPopin");
          }}
        />
      )}
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(MatriculeTabFlex);
